// 超时配置
export const TIMEOUT_CONFIG = {
  // 用户操作超时时间（分钟）
  USER_INACTIVITY_TIMEOUT: 30,
  
  // JWT token 刷新提前时间（分钟）
  TOKEN_REFRESH_BEFORE_EXPIRY: 5,
  
  // 超时警告提前时间（分钟）
  WARNING_BEFORE_TIMEOUT: 5,
  
  // 检查间隔时间（毫秒）
  CHECK_INTERVAL: 60000, // 1分钟
  
  // 最后操作时间存储键
  LAST_ACTIVITY_KEY: 'last_activity_time'
}

// 获取超时时间（毫秒）
export function getTimeoutMs() {
  return TIMEOUT_CONFIG.USER_INACTIVITY_TIMEOUT * 60 * 1000
}

// 获取警告时间（毫秒）
export function getWarningMs() {
  return TIMEOUT_CONFIG.WARNING_BEFORE_TIMEOUT * 60 * 1000
} 